<template>
  <div class="promocodeInput">
  <div class="promocodeInput__header">
    <div class="promocodeInput__title" v-on:click="show = !show">
      <img src="../../assets/images/promocode.svg" alt="">
      <span>{{ $t('qic_have_promocode') }}</span>
      </div>
    <div class="promocodeInput__optional">{{ $t('qic_optional') }}</div>
  </div>
  <transition name="fade">
    <div class="promocodeInput__input" v-if="show">
      <BaseInput
        :placeholder="$t('qic_promocode')"
        :value="value"
        :validation="$v.value"
        :mask="'X'.repeat(12)"
        name="promocode"
        autocomplete="off"
        @input="$emit('input', $event)"
        @blur="$emit('blur', value)"
        @focus="$emit('focus')"
      />
    </div>
  </transition>
</div>
</template>

<script>
import { maxLength } from 'vuelidate/lib/validators'
export default {
  props: [
    'value'
  ],
  data () {
    return {
      show: false
    }
  },
  validations: {
    value: {
      maxLength: maxLength(12)
    }
  }
}
</script>

<style lang="scss" scoped>
  .fade-enter-active, .fade-leave-active {
    transition: .15s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
    opacity: 0;
    transition: .04s;
  }
</style>

<style lang="scss">
.promocodeInput__input {
  .acceptInp, .acceptInp:hover {
    background-image: none;
  }
}
</style>
